:host {
  display: block;
}
.menu-label {
  font-family: var(--sc-font-sans);
  font-size: var(--sc-font-size-x-small);
  font-weight: var(--sc-font-weight-semibold);
  line-height: var(--sc-line-height-normal);
  letter-spacing: var(--sc-letter-spacing-normal);
  color: var(--sc-color-gray-500);
  padding: var(--sc-spacing-small) var(--sc-spacing-large);
  user-select: none;
  text-transform: uppercase;
}
